import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=0a77ca16"
import script from "./ProjectBoard.vue?vue&type=script&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&lang=js"
import style0 from "./ProjectBoard.vue?vue&type=style&index=0&id=0a77ca16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports